import type { LocaleMessageSchema } from '../types';

export default {
  Common: {
    loading: 'Загрузка...',
  },
  errors: {
    session_create_error:
      'Не удалось создать сессию.\nПожалуйста, попробуйте снова.',
    session_continue_error:
      'Не удалось загрузить вашу сессию. Пожалуйста, попробуйте снова. Если проблема сохраняется, обратитесь в поддержку: {supportEmail}.',
    kiosk_not_found:
      'Не удалось загрузить киоск.\nПожалуйста, попробуйте снова.',

    art_style_missing: 'В этот киоск не добавлены\n стили искусства',
    art_style_fetch_error: 'Не удалось загрузить стиль искусства',
    art_style_preload_error: 'Не удалось загрузить превью стиля искусства',

    face_detection_server_error:
      'Не удалось обработать фото. Пожалуйста, попробуйте снова.',
    face_detection_preload_error: 'Ошибка предзагрузки обнаруженных лиц',
    face_detection_no_faces:
      'Лица не обнаружены. Пожалуйста, попробуйте сделать другое фото.',

    photo_webcam_not_allowed: 'Доступ к веб-камере запрещён',
    photo_webcam_not_found:
      'Веб-камера не найдена. Пожалуйста, проверьте подключение к киоску.',
    photo_webcam_hardware_error:
      'Веб-камера занята или не работает.\nПопробуйте снова или обратитесь за помощью.',
    photo_webcam_photo_failed: 'Не удалось сделать фото\n с веб-камеры',

    photo_phone_missing_session_id:
      'Не удалось найти вашу сессию.\nПожалуйста, отсканируйте QR-код снова.',
    photo_phone_missing_kiosk_slug:
      'Киоск не найден в вашей сессии. Если проблема сохраняется, обратитесь в поддержку: {supportEmail}.',
    photo_phone_limit_exceeded: 'Выбрано слишком много фотографий',
    photo_phone_qr_error: 'Не удалось сгенерировать QR-код\nдля загрузки фото',

    photo_file_unsupported_type: 'Неподдерживаемый тип файла',
    photo_file_cannot_process:
      'Не удаётся обработать это фото.\nПожалуйста, попробуйте другое.',
    photo_file_cannot_process_heic:
      'Не удаётся обработать HEIC фото.\nПожалуйста, попробуйте другое.',

    portrait_generation_error:
      'Произошла ошибка при создании вашего портрета. Пожалуйста, попробуйте снова.',
    portrait_generation_faces_not_selected:
      'Не выбраны лица для\nсоздания портрета',
    portrait_generation_style_not_selected:
      'Не выбран стиль искусства для\nсоздания портрета',
    portrait_generation_over_limit: 'Слишком много попыток создания',

    portraits_download_session_error:
      'Не удалось найти вашу сессию. Пожалуйста, проверьте введённый код. Если проблема сохраняется, обратитесь в поддержку: {supportEmail}.',
    portraits_download_kiosk_error:
      'Киоск не найден в вашей сессии. Если проблема сохраняется, обратитесь в поддержку: {supportEmail}.',
    portraits_download_portraits_error:
      'В вашей сессии не найдены портреты. Если проблема сохраняется, обратитесь в поддержку: {supportEmail}.',

    payment_partner_mode_missing_stripe_account:
      'Режим оплаты партнёра требует аккаунт Stripe Connect. Настройте Stripe-аккаунт партнёра или переключитесь на режим оплаты платформы.',

    api_error_missing_session_id: 'Сессия не найдена',
    api_error_email_code_validation:
      'Не удалось проверить код оплаты. Пожалуйста, попробуйте снова.',
  },

  /**
   * Global components
   */

  OverlayError: {
    buttons: {
      close: 'Закрыть',
      restart: 'Начать Сначала',
      retry: 'Попробовать Снова',
    },
  },
  Logo: {
    startOver: 'Начать Сначала',
  },
  Copyright: {
    copyright: 'powered by TheArtisan.ai',
    distribution: 'распространяется',
    terms:
      'Делая фото на этом устройстве, вы принимаете наши правила и условия. Чтобы ознакомиться с ними,',
    termsLink: 'нажмите здесь',
  },
  IdlePopup: {
    title: 'Вы ещё здесь?',
    caption: 'Ваша сессия завершится при отсутствии активности.',
    buttonContinue: 'Да, я ещё здесь',
    buttonRestart: 'Нет, Начать Сначала',
  },
  GDPRConsent: {
    title: 'Требуется Согласие',
    consentText:
      'Нам нужно ваше согласие на обработку черт вашего лица (биометрических данных) для создания художественных преобразований. Вы можете продолжить, только если вам 16 лет или больше (или у вас есть согласие родителей).',
    buttonConsent: 'Я Согласен',
    buttonDecline: 'Я Не Согласен',
    privacyPolicyLink: 'Политика Конфиденциальности',
    declineMessage: 'Вы не можете продолжить без согласия',
  },
  StepProgressIndicator: {
    photoShort: 'Фото',
    photoLong: 'Сделать Фото',
    facesShort: 'Лица',
    facesLong: 'Выбрать Лица',
    groupPortraitsShort: 'Группа',
    groupPortraitsLong: 'Групповые Портреты',
    portraitsShort: 'Портреты',
    portraitsLong: 'Выбрать Портреты',
    printShort: 'Печать',
    printLong: 'Оплата и Печать',
    sendToPickupShort: 'Выдача',
    sendToPickupLong: 'Отправить на выдачу',
  },
  UploadedPhotosSidebar: {
    title: 'Ваши Фото',
    count: '+{extraPhotoCount} ещё',
  },
  NumericKeyboard: {
    invalidPin: 'Неверный PIN-код',
    clear: 'Очистить',
    enter: 'Ввод',
  },
  OutOfService: {
    message:
      'Ваш контракт приостановлен или истёк.\nПожалуйста, свяжитесь с вашим дистрибьютором для помощи.',
  },

  /**
   * Steps
   */

  Home: {
    title: 'Создайте свой портрет за секунды!',
    button: 'Попробовать!',
  },
  ArtStyle: {
    title: 'Выберите Стиль',
  },
  PhotoFromWebcam: {
    titleGetReady: 'Приготовьтесь к фото',
    titleAttention: 'Смотрите в камеру!',
    titleReview: 'Вам нравится это фото?',
    titleUpload: 'Загрузка вашего фото...',
    buttonPrimaryPhoto: 'Сделать Фото',
    buttonPrimaryUse: 'Да, Использовать Это Фото',
    buttonPrimaryRetake: 'Переснять',
    buttonSecondaryUpload: 'Загрузить с Телефона',
    buttonSecondaryRetake: 'Нет, Переснять (Осталась 1 Попытка)',
    buttonSecondaryUseFirst: 'Нет, Использовать Первое Фото',
    titleCameraError: 'Камера недоступна',
    buttonRetryCamera: 'Повторить',
  },
  PhotoPromptFromPhone: {
    title: 'Загрузить Фото с Телефона?',
    caption:
      'Удивите друзей и семью —\nзагрузите их фото для создания портретов.',
    buttonUpload: 'Да, Загрузить с Телефона',
    buttonSkip: 'Нет, Пропустить',
  },
  PhotoFromPhone: {
    title: 'Загрузите фото с телефона',
    step1: 'Отсканируйте QR-код телефоном',
    step2: 'Выберите фотографии',
    step3: 'Дождитесь загрузки',
    waiting: 'Ожидание загрузки...',
    done: 'Загрузка завершена',
    buttonCancel: 'Отмена и Назад',
    buttonSkip: 'Пропустить Загрузку',
    buttonContinue: 'Продолжить',
    gdprConsentAll:
      'У меня есть согласие всех людей на фото на обработку их черт лица',
    gdprOver16: 'Никому на этом фото нет меньше 16 лет',
    gdprResponsibility: 'Я принимаю полную ответственность за соблюдение GDPR',
    gdprAgreeToPrefix: 'Я согласен с',
    gdprPrivacyPolicyLink: 'Политикой Конфиденциальности',
    gdprAgreeToSuffix: 'условиями для загруженных фото',
    gdprCheckboxesRequired:
      'Пожалуйста, отметьте все поля ниже для продолжения',
    buttonSkipKioskPhoto: 'Пропустить фото с киоска',
    buttonTakeWebcamPhoto: 'Сделать фото с веб-камеры',
  },
  FacesIndividual: {
    title: 'Выберите, кто будет на портретах?',
    buttonConfirm: 'Подтвердить и Продолжить',
    genderMale: 'Мужской',
    genderFemale: 'Женский',
    genderNonBinary: 'Небинарный',
    age0to2: '0-2',
    age3to9: '3-9',
    age10to19: '10-19',
    age20to29: '20-29',
    age30to39: '30-39',
    age40to49: '40-49',
    age50to59: '50-59',
    age60to69: '60-69',
    age70plus: '70+',
    raceWhite: 'Белый',
    raceBlack: 'Чёрный',
    raceEastAsian: 'Восточноазиатский',
    raceSoutheastAsian: 'Юго-восточноазиатский',
    raceIndian: 'Индийский',
    raceLatino: 'Латиноамериканский',
    raceMena: 'Ближневосточный',
  },
  Portraits: {
    title: 'Выберите свои портреты!',
    buttonNext: 'Далее: Печать Выбранных',
    buttonNextGroupOnly: 'Продолжить только с групповыми портретами',
    galleryScrollBack: 'Предыдущие портреты',
    galleryScrollForward: 'Следующие портреты',
    filterLabel: 'Показать',
    filterAll: 'Все',
    filterGroup: 'Вместе',
    filterIndividual: 'По одному',
    stageKindGroup: 'Групповой портрет',
    stageKindIndividual: 'Портрет',
    stagePosition: '{index} из {count}',
    stageSelect: 'Выбрать',
    stageSelected: 'Выбрано ✓',
    buttonMore: 'Создать ещё портреты (осталось {count})',
    popupTitle: 'Хотите завершить заказ?',
    popupGroupSelected: 'Групповых портретов выбрано: {count} ({price})',
    popupIndividualSelected:
      'Индивидуальных портретов выбрано: {count} ({price})',
    popupTotalSum: 'Итого: {sum}',
    popupButtonNo: 'Нет, назад',
    popupButtonYes: 'Да, печать и оплата!',
    error: 'Упс! Не удалось создать этот портрет.',
    placeholderGenerating: 'Создание вашего портрета...',
    placeholderLoading: 'Загрузка вашего портрета...',
    groupPlaceholder: 'Здесь появится ваш групповой портрет',
    buttonRetry: 'Попробовать Снова',
    buttonErrorDetails: 'Детали Ошибки',
    retrying: 'Повтор...',
    maxRetriesReached: 'Макс. попыток достигнуто',
    retryAttempts: 'Попытки: {count}',
    printingLockedPopupTitle:
      'Пожалуйста, позовите ближайшего сотрудника для печати ваших портретов.',
    generationPendingTitle: 'Некоторые портреты ещё создаются',
    generationPendingCaption:
      'Ещё создаются портреты: {count}. Подождать, чтобы увидеть их все?',
    generationPendingWait: 'Дождаться всех',
    generationPendingSendReady: 'Отправить готовые портреты: {count}',
    printingLockedPopupCaption:
      'Печать на киоске недоступна, пока сотрудник отсутствует.',
  },
  PortraitsGroup: {
    buttonMore: 'Создать ещё портреты',
  },
  PrintLock: {
    lockTitle: 'Заблокировать печать',
    unlockTitle: 'Разблокировать печать',
  },
  PaymentType: {
    title: 'Выберите способ оплаты',
    optionCardTitle: 'Банковская Карта',
    optionCardCaption: 'Visa, Mastercard и 10+ поддерживаемых карт',
    optionVoucherTitle: 'Оплаченные портреты',
    optionVoucherCaption: 'Включены в билет — обратитесь к персоналу',
  },
  PaymentTerminal: {
    title: 'Пожалуйста, следуйте инструкциям на платёжном терминале',
    titlePaymentSuccess: 'Печать ваших портретов...',
    titlePaymentError: 'Ошибка оплаты',
    titlePrintError1: 'Некоторые портреты не удалось напечатать.',
    titlePrintError2: 'Пожалуйста, нажмите "Печатать Снова" ниже для повтора.',
    buttonRetryPrinting: 'Печатать Снова',
    buttonRetry: 'Повторить',
    buttonCancel: 'Отмена',
    buttonExitSession: 'Начать сначала',
    buttonBack: 'Назад',
    total: 'Итого:',
    captionPayment: 'Ожидание оплаты...',
    captionPrinting: 'Оплата успешна',
    captionPaymentError:
      'Что-то пошло не так. Пожалуйста, повторите или начните сначала.',
    captionPaymentFinal: 'Оплата не прошла. Обратитесь к сотруднику.',
    failureCaptions: {
      notEnoughFunds: 'На карте недостаточно средств. Попробуйте другую карту.',
      expiredCard: 'Срок действия карты истёк. Попробуйте другую карту.',
      cardDeclined: 'Карта отклонена. Попробуйте другую карту.',
      cardError:
        'Эту карту нельзя использовать здесь. Попробуйте другую карту.',
      processingError: 'Платёж не прошёл. Попробуйте ещё раз с той же картой.',
      readerError: 'Терминал для карт недоступен. Обратитесь к сотруднику.',
      timeout: 'Время оплаты истекло. Попробуйте ещё раз.',
    },
    errorMessage: 'К сожалению, не удалось обработать ваш платёж',
    popupCancelledTitle: 'Оплата отменена',
    popupCancelledCaption: 'Хотите повторить или начать сначала?',
    popupButtonContinue: 'Повторить',
  },
  PaymentVoucher: {
    title: 'Пожалуйста, позовите сотрудника для помощи с оплатой ваучером',
    buttonBack: 'Назад',
    pinTitle: 'Оплата ваучером',
  },
  Printing: {
    title: 'Печать ваших портретов...',
    titleError: 'Извините, некоторые портреты не удалось напечатать',
    buttonPrintAgain: 'Печатать Снова',
    buttonContinueWithoutPrint: 'Продолжить без печати',
    error: 'Упс! Не удалось напечатать этот портрет.',
    errorPartial: 'Напечатано {printed} из {total}',
    retrying: 'Новая попытка…',
    waiting: 'Ждём принтер…',
  },
  PrintFailed: {
    title: 'Извините, мы не смогли напечатать ваши фото',
    titlePartial: 'Напечатано {printed} из {total} фото',
    caption: 'Вы можете начать новую сессию и создать новые портреты.',
    captionRefunded: 'Мы вернули {amount} на вашу карту.',
    captionNotCharged: 'Мы не списали {amount} с вашей карты.',
    captionRefundHelp: 'Сотрудник поможет вам с возвратом денег.',
  },
  Success: {
    title: 'Спасибо!',
    caption: 'Ваши картины напечатаны. Пожалуйста, заберите их на стойке.',
    buttonStartAgain: 'Начать Снова',
  },
  GoPhotoScan: {
    title: 'Отсканируйте ваш PhotoPass',
    subtitle: 'Поднесите QR-код вашего PhotoPass к сканеру',
    invalidCode: 'Неверный формат кода. Пожалуйста, отсканируйте снова.',
    failedToRegister:
      'Не удалось зарегистрировать код. Пожалуйста, попробуйте снова.',
    error: 'Произошла ошибка. Пожалуйста, попробуйте снова.',
  },

  /**
   * Customer-facing components
   */

  CustomerPhotoFromPhone: {
    title: 'Загрузите фото из галереи',
    buttonSelect: 'Выбрать Фото',
    maxCount: 'Максимум {count} фото',
    uploading: 'Загрузка...',
    uploadError:
      'Не удалось загрузить. Пожалуйста, проверьте подключение и попробуйте снова.',
    buttonRetry: 'Попробовать Снова',
    successTitle: 'Загрузка завершена',
    successCaption:
      'Пожалуйста, вернитесь к киоску и следуйте инструкциям на экране.',
  },
  CustomerPortraitsDownload: {
    title: 'Введите Код для Получения Портрета',
    buttonSubmit: 'Отправить',
    error:
      'Похоже, код введён неверно. Проверьте код из 8 символов, напечатанный на фотографии, и попробуйте снова.',
    errors: {
      wrongFormat:
        'Похоже, код введён неверно. Проверьте код из 8 символов, напечатанный на фотографии, и попробуйте снова.',
      notFound:
        'К сожалению, портреты не найдены. Проверьте код — он напечатан на передней части портрета, внизу слева.',
      serverError:
        'К сожалению, не удалось получить ваши портреты. Пожалуйста, попробуйте позже.',
    },
  },
  CustomerSessionPass: {
    tabs: {
      photos: 'Фото',
      pass: 'Билет с QR',
    },
    eyebrow: 'Ваш пропуск сессии',
    title: 'Не закрывайте эту страницу',
    description:
      'На станции покупки отсканируйте квадратный код ниже. Ваши портреты доступны во вкладке «Фото».',
    descriptionNothingPrinted:
      'На станции покупки отсканируйте квадратный код ниже, чтобы выбрать и напечатать свои фотографии.',
    scanLabel: 'Сканировать на станции покупки',
    codeLabel: 'Код сессии',
    ready: 'Готово к сканированию',
    loading: 'Подготовка кода',
    unavailable: 'Код недоступен',
    qrAlt: 'QR-код для станции покупки',
    defaultVenue: 'Портретный опыт TheArtisan.ai',
  },
  CustomerPortraitsDownloadCode: {
    error: 'Упс! Не удалось загрузить этот портрет.',
    placeholder: 'Загрузка вашего портрета...',
    imageAlt: 'Портрет',
    buttonDownload: 'Скачать',
    buttonSendOrShare: 'Отправить или Поделиться',
    buttonRetry: 'Попробовать Снова',
    shareTitle: 'Ваш портрет от {clientName}',
    shareText: 'Powered by TheArtisan.ai',
    states: {
      processing:
        'Ваши портреты ещё обрабатываются. Попробуйте снова через некоторое время.',
      partial:
        'Некоторые портреты или элементы страницы не загрузились. Доступные скачивания продолжают работать.',
    },
    actions: {
      enterAnotherCode: 'Ввести другой код',
      contactSupport: 'Связаться с поддержкой',
      retryDownload: 'Повторить скачивание',
      downloadFailed:
        'Не удалось скачать файл. Проверьте соединение и попробуйте снова.',
      linkCopied: 'Ссылка скопирована. Её можно вставить в сообщение.',
      shareFailed: 'Сейчас не удалось поделиться портретом. Попробуйте снова.',
    },
  },
  CustomerDigitalExtras: {
    downloadTitle: 'Ваши фото и видео',
    downloadIntro: 'Скачайте фото и видео или откройте QR-билет.',
    photosTitle: 'Ваши фото',
    photosIntro: 'Скачайте фото или откройте билет с QR.',
    navigation: 'Ваши материалы',
    tabs: {
      photos: 'Фото',
      extras: 'Видео',
      pass: 'QR-билет',
    },
    title: 'Ваши цифровые товары',
    loading: 'Загружаем ваши допы…',
    loadError: 'Не удалось загрузить файлы. Проверьте подключение и повторите.',
    included: 'Включено',
    includedOrder:
      'Видео бесплатно. Сохраните QR-билет, чтобы открыть его позже.',
    preparingHelp:
      'Сохраните эту ссылку или QR-билет. Страницу можно закрыть и вернуться к ней позже.',
    reference: 'Номер для обращения: {reference}',
    retry: 'Повторить',
    empty: 'К этому визиту пока не добавлены цифровые товары.',
    orderTitle: 'Заказ видео',
    showCashier: 'Покажите этот заказ и QR-билет кассиру.',
    videoTotal: 'Итого за видео',
    payAtDesk: 'Оплата у кассира.',
    preparing: 'Готовим файлы…',
    failed:
      'Не удалось подготовить видео. Покажите номер ниже сотруднику площадки, чтобы получить помощь.',
    ready: 'Готово к скачиванию',
    video: 'Живое фото',
    videoDescription:
      'Ваш любимый момент в движении. Для историй и семейного чата.',
    download: 'Скачать',
    share: 'Поделиться файлом',
    preparingShare: 'Загружаем файл…',
    shareFailed: 'Поделиться не удалось. Сохраните файл кнопкой «Скачать».',
  },
  GoPhotoUpload: {
    waitingForPortraits: 'Завершаем ваши портреты',
    waitingForPortraitsSubtitle:
      'Подождите, пока создаются оставшиеся портреты.',
    success: 'Фото загружены!',
    successSubtitle: 'Ваши фото теперь доступны на PhotoPass.',
  },
  system: {
    reconnecting: 'Переподключение к серверу…',
  },
} satisfies LocaleMessageSchema;
